import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/header'
import Menu from './menu'
import { staticContentsImagePath as BASE_IMAGE_PATH } from '../configs/const';
class BinaryCommingSoon extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            toastMsg: "",
            toastType: "",
            showToast: false,
        };
    }
    componentDidMount() {
    }
    onChange(e) {
        const name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
    }
    render() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        return (
            <body className="radheexch">
                <Header notify={this.props.notify} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <Menu history={this.props.history} />
                    <div className="col-center1 markets">
                        <div className="cricket">
                            <div className="sub_path center-box"><p>Binary</p></div>
                            <div className="game-wrap col3 ">
                                <div className="text-center">
                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/coming-soon.svg"} ></img>
                                </div>
                                <p className="coming-soon">Coming Soon<br /><br /></p>
                            </div>
                        </div>
                    </div>
                </div>
            </body>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(BinaryCommingSoon);